module.exports = __webpack_public_path__ + "static/media/integrately.9ba1c01d.webp";